import createCachedSelector from 're-reselect'
import { any } from 'util/arrays'
import { makeSelectRequest, selectBase as selectRequests } from 'ducks/requests'
import { selectContactsById } from './base'

function getCustomerIdFromProps(state, { customerId } = {}) {
  return customerId
}

const selectContactForCustomerId = createCachedSelector(
  selectContactsById,
  getCustomerIdFromProps,
  (byId, customerId) => {
    return byId[customerId]
  }
)(getCustomerIdFromProps)

const selectIsContactPropertiesRequest = makeSelectRequest(
  'integrations/hubspot/fetchContactProperties'
)
const selectIsCompanyPropertiesRequest = makeSelectRequest(
  'integrations/hubspot/fetchCompanyProperties'
)
const selectIsDealPropertiesRequest = makeSelectRequest(
  'integrations/hubspot/fetchDealProperties'
)

function makeSelectIsRequestForCustomerId(requestKeyBase) {
  return createCachedSelector(
    selectRequests,
    getCustomerIdFromProps,
    (requests, customerId) =>
      requests[`integrations/hubspot/${requestKeyBase}:${customerId}`]
  )(getCustomerIdFromProps)
}

const selectIsContactRequestForCustomerId = makeSelectIsRequestForCustomerId(
  'fetchContact'
)
const selectIsContactCompanyRequestForCustomerId = makeSelectIsRequestForCustomerId(
  'fetchContactCompany'
)
const selectIsContactListsRequestForCustomerId = makeSelectIsRequestForCustomerId(
  'fetchContactLists'
)
const selectIsContactDealsRequestForCustomerId = makeSelectIsRequestForCustomerId(
  'fetchContactDeals'
)
const selectIsOwnersRequestForCustomerId = createCachedSelector(
  selectRequests,
  selectContactForCustomerId,
  (requests, contact) => {
    const owner =
      contact && contact.properties && contact.properties.hubspot_owner_id
    const ownerId = owner && owner.value
    return requests[`integrations/hubspot/fetchOwner:${ownerId}`]
  }
)(getCustomerIdFromProps)

function makeSelectRequestPropertyForCustomerId(key) {
  return createCachedSelector(
    selectIsContactPropertiesRequest,
    selectIsCompanyPropertiesRequest,
    selectIsDealPropertiesRequest,
    selectIsContactRequestForCustomerId,
    selectIsContactCompanyRequestForCustomerId,
    selectIsContactListsRequestForCustomerId,
    selectIsContactDealsRequestForCustomerId,
    selectIsOwnersRequestForCustomerId,
    (...loadings) => {
      const result =
        loadings && any(request => request && request[key], loadings)
      return result
    }
  )(getCustomerIdFromProps)
}

export const selectIsCustomerLoadingForCustomerId = makeSelectRequestPropertyForCustomerId(
  'loading'
)
export const selectIsCustomerErroredForCustomerId = makeSelectRequestPropertyForCustomerId(
  'error'
)
